import { persistor, type AppDispatch } from "../../app/store";
import { goToPage } from "../../utils/utils";
import { storeEmployees } from "./employeeSlice";

/*
 Porta alla pagina di prenotazione del corso con i dipendenti scelti.

 `goToPage` ricarica la pagina, e la pagina nuova rilegge i dipendenti da
 sessionStorage. redux-persist ci scrive in differita, a colpi di timer: si
 naviga solo dopo `persistor.flush()`, altrimenti la pagina di prenotazione
 puo' partire con la selezione precedente, o vuota.
*/
export function vaiAllaPrenotazione(
  dispatch: AppDispatch,
  cfDiscenti: string[],
  codiceCorso: string
): Promise<void> {
  dispatch(storeEmployees(cfDiscenti));
  return persistor
    .flush()
    .finally(() => goToPage("corso", `${codiceCorso.toLowerCase()}/-1`));
}
